<template>
  <div class="c-table" ref="smartptomTable">
    <el-table
      class="common-el-table-styles"
      ref="table"
      v-loading="loading"
      :data="data"
      :height="height"
      border
      stripe
      @sort-change="sortChange"
    >
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'convertIndex'">{{ getConvertType(scope.row[col.key]) }}</span>
          <div v-else-if="col.key === 'enable'">
            <i-Switch v-model="scope.row[col.key]" :true-value="1" :false-value="0" @on-change="changeActive(scope.row)" size="small" />
          </div>
          <span v-else-if="['createTime', 'updateTime'].includes(col.key)">{{ scope.row[col.key] | datetimeToSec }}</span>
          <div v-else-if="col.key === 'control'" class="control-btns">
            <el-button type="text" @click="editClick(scope.row)">修改</el-button>
            <el-button type="text" @click="copyClick(scope.row)">复制</el-button>
            <el-button type="text" @click="planClick(scope.row)">计划分析</el-button>
          </div>
          <el-button type="text" v-else-if="col.key === 'havePlanNum'" @click="planClick(scope.row)">{{ scope.row[col.key] }}</el-button>
          <span
            v-else-if="['pv', 'clickNum', 'paperUseAmount', 'amount', 'newRoleMoney', 'newDeviceMoney', 'sumMoney'].includes(col.key)"
            >{{ scope.row[col.key] | toThousands }}</span
          >
          <span v-else-if="col.key.indexOf('Rate') > -1 || col.key.indexOf('Retain') > -1">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { timeout, setLocalInfo } from '@/common/js/utils'
import convertData from '@/data/toutiao/convert_data'
import { monitorProjectSwitch } from '@/api/manage.model' // , editAdBudget, editPlanBid

export default {
  name: 'policyTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    summary: {
      type: Object
    },
    type: {
      type: String
    },
    height: {
      type: Number
    },
    datetime: {
      type: Array
    }
  },
  methods: {
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    editClick(row) {
      const { projectId } = row
      const account = Cookies.get('ch_user_name')
      const id = Cookies.get('ch_op_id')
      setLocalInfo(id, account, '10')
      window.open(`/create/robot/monitor?id=${projectId}&t=edit`, '_blank')
    },
    copyClick(row) {
      const { projectId } = row
      const account = Cookies.get('ch_user_name')
      const id = Cookies.get('ch_op_id')
      setLocalInfo(id, account, '10')
      window.open(`/create/robot/monitor?id=${projectId}`, '_blank')
    },
    planClick(row) {
      const { projectId } = row
      const [beginTime, endTime] = this.datetime
      this.$router.push({ name: 'smartptomplan', query: { projectId, beginTime, endTime } })
    },
    getCpaBidType(type) {
      return type === 1 ? '期望出价' : type === 0 ? '系统推荐' : '换行测试'
    },
    getConvertType(val) {
      const convert = this.convertData.filter((ret) => ret.key === val).pop()
      if (convert) return convert.value
      return '未知'
    },
    // 开关
    changeActive(row) {
      const { projectId, enable } = row
      if ([1, 0].includes(enable)) {
        this.betch(projectId, enable)
      }
    },
    betch(projectId, enable) {
      monitorProjectSwitch({
        projectId,
        enable
      }).then((data) => {
        if (data) {
          this.$Message.success({
            duration: 5,
            content: '操作成功'
          })
          this.$emit('on-refresh')
        }
      })
    },
    doLayout() {
      this.$refs.table.doLayout()
    }
  },
  data() {
    return {
      convertData: convertData,
      switchStatus: true
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  .control-btns {
    button {
      margin: 0;
    }
  }
}
</style>
